import { useCallback, useState } from 'react';

import type { SnackbarCloseReason } from '@mui/material';
import type { SyntheticEvent } from 'react';

export const useSnackbar = () => {
  const [open, setOpen] = useState(false);

  const onOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const onClose = useCallback(
    (_?: SyntheticEvent | Event, reason?: SnackbarCloseReason) => {
      if (reason === 'clickaway') {
        return;
      }

      setOpen(false);
    },
    [],
  );

  return { open, onOpen, onClose };
};
